import { Button, Box, Tooltip } from '@mui/material';

type WhiteButtonProps = {
  cb: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  label: string;
  icon?: React.ReactNode;
  tooltip?: string;
  square?: boolean;
  classes?: string;
  className?: string;
};

export default function WhiteButton({
  cb,
  disabled,
  label,
  icon,
  tooltip,
  square,
  classes,
  className,
  ...props
}: WhiteButtonProps): JSX.Element {
  const baseClassName = [
    'bg-white',
    ...(square ? ['px-6', 'py-6'] : ['px-16', 'py-8']),
    'rounded-8',
    'border',
    'border-solid',
    'border-border',
    'font-600',
    'text-14',
    'text-typography-primary',
    'hover:bg-neutral-200',
    'disabled:opacity-50',
    'hover:bg-neutral-200',
    'disabled:opacity-50',
    'transition-[opacity,background-color]',
    'min-w-0',
    'min-w-0',
  ];

  const button = (
    <Button
      onClick={cb}
      disabled={disabled}
      className={`${baseClassName.join(' ')} ${classes || ''} ${className || ''}`}
      {...props}
    >
      {icon && <Box className="mr-10">{icon}</Box>}
      {label}
    </Button>
  );

  if (!tooltip) return button;

  return (
    <Tooltip title={tooltip} arrow>
      {button}
    </Tooltip>
  );
}
